import { render, staticRenderFns } from "./fields-list.vue?vue&type=template&id=e4bac084&scoped=true&"
import script from "./fields-list.vue?vue&type=script&lang=js&"
export * from "./fields-list.vue?vue&type=script&lang=js&"
import style0 from "./fields-list.vue?vue&type=style&index=0&id=e4bac084&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bac084",
  null
  
)

export default component.exports